<template>
  <v-main>
    <!-- TOP IMAGE -->
    <v-container
      class="col-10 pa-0 ma-0-auto mt-4 d-flex flex-column flex-lg-row page-wrapper mb-16"
    >
      <v-img
        src="@/assets/images/entrypages/pexels-pixabay-50711.jpg"
        height="250"
      >
        <div style="margin-top: 30px; margin-left: 30px; ">
          <h4 class="page-title">
            <span
              style="background-color: white ; opacity: 0.9; padding: 10px;"
            >
              {{ $t(menu).content.title }}</span
            >
          </h4>
        </div>
      </v-img>
    </v-container>

    <v-container
      class="col-10 pa-0 ma-0-auto d-flex flex-column flex-lg-row page-wrapper"
    >
      <div class="col-12 col-lg-3 pa-0 page-sidebar">
        <SideMenu
          class="d-none d-lg-block"
          page="/industry/"
          :menu="menu"
          @menuContent="passMenuContent"
        ></SideMenu>
      </div>

      <div class="col-12 col-lg-9 pa-0 pl-lg-12 page-content">
        <Mentor
          v-if="this.$route.params.slug === 'mentor'"
          :content="content"
        />
        <Technologies
          v-else-if="this.$route.params.slug === 'technologies'"
          :content="content"
        />
        <Sponsorship
          v-else-if="this.$route.params.slug === 'sponsorship'"
          :content="content"
        />
        <SpinoffList
          v-else-if="this.$route.params.slug === 'spinoff-list'"
          :content="content"
        />

        <PartnershipCollaborations
          v-else-if="this.$route.params.slug === 'partnership'"
          :content="content"
        />
        <Collab
          v-else-if="this.$route.params.slug === 'collab'"
          :content="content"
        />
        <FindYourResearchPartner
          v-else-if="this.$route.params.slug === 'find-your-research-partner'"
          :content="content"
        />

        <Cooperation
          v-else-if="this.$route.params.slug === 'cooperation'"
          :content="content"
        />
        <Calls
          v-else-if="this.$route.params.slug === 'calls'"
          :content="content"
        />

        <div v-else-if="this.$route.fullPath.endsWith('industry')">
          <Home :content="$t(menu).content" />
          <div>
            <SideMenu
              class="d-lg-none mt-10"
              page="/industry/"
              :menu="menu"
              @menuContent="passMenuContent"
            ></SideMenu>
          </div>
        </div>

        <NotFound v-else :menu="menu" />
      </div>
    </v-container>
  </v-main>
</template>

<script>
import SideMenu from '@/components/SideMenu'
import Home from './Industry/Home'
import Mentor from './Industry/Mentor'
import Sponsorship from './Industry/Sponsorship'
import SpinoffList from './Academics/SpinoffList'
import Collab from './Industry/Collab'
import Cooperation from './Industry/Cooperation'
import Calls from './Industry/Calls'
import PartnershipCollaborations from './Industry/PartnershipCollaborations'
import FindYourResearchPartner from './Industry/FindYourResearchPartner'

export default {
  name: 'Industry',
  components: {
    SideMenu,
    Home,
    Mentor,
    Sponsorship,
    SpinoffList,
    Collab,
    Cooperation,
    Calls,
    PartnershipCollaborations,
    FindYourResearchPartner,
  },
  data() {
    return {
      search: null,
      caseSensitive: false,
      menu: 'SideMenuIndustry',
      content: {},
    }
  },
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    },
  },
  methods: {
    passMenuContent(content) {
      this.content = content
    },
  },
}
</script>

<style lang="scss">
.industry-page {
  h2 {
    @extend .content-title;
  }

  .industry-text {
    @extend .content-body;
  }

  .v-expansion-panels {
    border: 1px solid #878a8c !important;
  }
}

.page-title {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 20px !important;
  }
}
</style>
